import {fetchCondition} from '../../../services/assetListService'
import {assetsListActions} from '../assets'

const getConditions = () => {
  return (dispatch) => {
    dispatch(assetsListActions.getConditionsRequest())
    fetchCondition().then((res) => {
      dispatch(assetsListActions.getConditionsSuccess(res))
    }).catch((error) => {
      dispatch(assetsListActions.getConditionsFailure(error))
    })
  }
}

export default getConditions
